var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { withRouter } from "react-router-dom";
import { GamesMenuFooter } from "../styles";
import favoriteIcon from "../../../../assets/img/games/favorite.png";
import homeIcon from "../../../../assets/img/games/home.png";
import recentIcon from "../../../../assets/img/games/recent.png";
import { injectIntl, defineMessages } from "react-intl";
var menuItems = [
    {
        icon: favoriteIcon,
        label: "favorites",
    },
    {
        icon: homeIcon,
        label: "home",
    },
    {
        icon: recentIcon,
        label: "recent",
    },
];
var messages = defineMessages({
    favorites: {
        id: "games.favorites",
        defaultMessage: "Избранное",
    },
    home: {
        id: "games.home",
        defaultMessage: "Главная",
    },
    recent: {
        id: "games.recent",
        defaultMessage: "Недавние",
    },
});
var GamesMenu = /** @class */ (function (_super) {
    __extends(GamesMenu, _super);
    function GamesMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getByPath = function (label) {
            var _a = _this.props, getToPinnedGames = _a.getToPinnedGames, getToRecentArrivedGames = _a.getToRecentArrivedGames;
            switch (label) {
                case "home":
                    _this.props.clearSearchField();
                    _this.props.cancelFiltering();
                    _this.props.goToLobbyGames();
                    break;
                case "recent":
                    getToRecentArrivedGames();
                    break;
                case "favorites":
                    getToPinnedGames();
                    break;
                default:
            }
        };
        return _this;
    }
    GamesMenu.prototype.render = function () {
        var _this = this;
        return (_jsx("div", __assign({ style: { display: "flex", justifyContent: "center" } }, { children: _jsx(GamesMenuFooter, { children: menuItems.map(function (menuItem) {
                    return (_jsxs("div", __assign({ onClick: function (e) {
                            _this.getByPath(menuItem.label);
                        } }, { children: [_jsx("img", { src: menuItem.icon, alt: "menu-icon" }), _jsx("p", { children: _this.props.intl.formatMessage(messages[menuItem.label]) })] }), menuItem.label));
                }) }) })));
    };
    return GamesMenu;
}(React.Component));
export default withRouter(injectIntl(GamesMenu));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesMenu/GamesMenu.jsx